/* eslint-disable no-unused-vars */

/** remove object props without value
 * @description removes props with null or undefined values
 */
export const cleanupObject = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => !!v || v === 0))
}

export const cleanupObjectWithArrays = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => {
      if (Array.isArray(v)) {
        return !!v.length
      } else {
        return !!v || v === 0
      }
    })
  )
}

export const areAllObjectPropsEmpty = (obj, options = {}) => {
  const { ignore = [] } = options

  let areAllEmpty = true
  Object.entries(obj).forEach(([key, value]) => {
    if (!ignore.includes(key) && (!!value || value === false)) {
      areAllEmpty = false
    }
  })

  return areAllEmpty
}

export const areAllArrayObjectsEmpty = (array, options = {}) => {
  let notEmpty = true

  array.forEach((obj) => {
    notEmpty = notEmpty && !areAllObjectPropsEmpty(obj, options)
  })

  return !notEmpty
}
